import type { RootState } from './setup/store';

export const isAppInMaintenanceMode = (_state: RootState) => false;
